module.exports = __webpack_public_path__ + "static/img/91-3.6be9c2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/91-3.jpg
// module id = cfjx
// module chunks = 0